var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcVoterId = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "33px",
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FC57F12B-C5C2-4668-B852-CCD65CB86BBA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "POC-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00.00.01-Validation:-Document-type",
    transform: "translate(-32.000000, -309.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(24.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cells",
    transform: "translate(0.000000, 140.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Passport",
    transform: "translate(8.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.333333, 4.666667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-admin_mid",
    transform: "translate(2.999959, 3.000000)",
    fill: "#676767",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2000409,0 C8.40022681,0 10.1747535,1.89359671 10.1747535,4.21904762 C10.1747535,5.93281808 9.21098333,7.41204251 7.82333346,8.07165159 C10.10095,8.93507753 11.8720912,11.6195 12.3968728,15.3985963 C12.422194,15.5809415 12.2949009,15.7492884 12.1125557,15.7746096 C11.9302105,15.7999309 11.7618636,15.6726378 11.7365424,15.4902926 C11.1335887,11.1482571 8.84762458,8.43809524 6.2000409,8.43809524 C3.55283297,8.43809524 1.2674788,11.1478603 0.663529787,15.490362 C0.638170215,15.6727019 0.469796544,15.7999596 0.287456668,15.7746 C0.105116792,15.7492404 -0.0221408879,15.5808668 0.00321868481,15.3985269 C0.528853786,11.6191162 2.2996966,8.93493777 4.57728452,8.07040703 C3.18909848,7.41204251 2.22532826,5.93281808 2.22532826,4.21904762 C2.22532826,1.89359671 3.99985499,0 6.2000409,0 Z M6.2000409,0.666666667 C4.37807029,0.666666667 2.89199493,2.25245704 2.89199493,4.21904762 C2.89199493,6.1856382 4.37807029,7.77142857 6.2000409,7.77142857 C8.02201152,7.77142857 9.50808688,6.1856382 9.50808688,4.21904762 C9.50808688,2.25245704 8.02201152,0.666666667 6.2000409,0.666666667 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.9333333,0 C27.3633862,0 29.3333333,1.9699471 29.3333333,4.4 L29.3333333,18.2666667 C29.3333333,20.6967196 27.3633862,22.6666667 24.9333333,22.6666667 L4.4,22.6666667 C1.9699471,22.6666667 0,20.6967196 0,18.2666667 L0,4.4 C0,1.9699471 1.9699471,0 4.4,0 L24.9333333,0 Z M24.9333333,0.666666667 L4.4,0.666666667 C2.41450223,0.666666667 0.791014797,2.21661715 0.67348006,4.17257574 L0.666666667,4.4 L0.666666667,18.2666667 C0.666666667,20.2521644 2.21661715,21.8756519 4.17257574,21.9931866 L4.4,22 L24.9333333,22 C26.9188311,22 28.5423185,20.4500495 28.6598533,18.4940909 L28.6666667,18.2666667 L28.6666667,4.4 C28.6666667,2.41450223 27.1167162,0.791014797 25.1607576,0.67348006 L24.9333333,0.666666667 Z",
    id: "Rectangle",
    fill: "#666666",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF0000",
    x: 17.6,
    y: 6.04444444,
    width: 8.8,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#676767",
    x: 17.6,
    y: 9.06666667,
    width: 8.8,
    height: 1,
    rx: 0.275
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcVoterId);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_voter_id.68d097ccff65f9f4565b5ae9224c737b.svg";